/* import __COLOCATED_TEMPLATE__ from './workflow-state-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    stateName: string;
    lastUpdatedAt: Date;
    lastUpdatedBy?: { firstNameOrNameOrEmail: string };
    lastSavedAt?: Date;
    showDraftChangesIndicator: boolean;
  };
}

const WorkflowStateStampComponent = templateOnlyComponent<Signature>();
export default WorkflowStateStampComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentEditor::Headers::WorkflowStateStamp': typeof WorkflowStateStampComponent;
  }
}
